/**
 * Exports API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  downloadEslogExport,
  downloadPdfExport,
  exportDocuments,
  exportSalesPerItem,
  getPdfExportStatus,
  startEslogExport,
  startPdfExport,
} from "../generated/exports/exports";

import { wrapListMethod, wrapMethod } from "./utils";

const exportsApi = {
  /** @see exportDocuments */
  exportDocuments: wrapMethod(exportDocuments),

  /** @see exportSalesPerItem */
  exportSalesPerItem: wrapMethod(exportSalesPerItem),

  /** @see startPdfExport */
  startPdfExport: wrapMethod(startPdfExport),

  /** @see getPdfExportStatus */
  list: wrapListMethod(getPdfExportStatus),

  /** @see downloadPdfExport */
  downloadPdfExport: wrapMethod(downloadPdfExport),

  /** @see startEslogExport */
  startEslogExport: wrapMethod(startEslogExport),

  /** @see downloadEslogExport */
  downloadEslogExport: wrapMethod(downloadEslogExport),
} as const;

export type ExportsApi = typeof exportsApi;

export { exportsApi as exports };
